import React, { useRef, useEffect, useCallback } from 'react';
import { CSSTransition } from 'react-transition-group';
import cn from 'classnames';

import IconButton, { ICON } from 'components/common/IconButton';
import { useScrollBlock } from 'hooks/useScrollBlock';
import { useUnmount } from 'hooks/useUnmount';
import { useHeaderHeight } from 'hooks/useHeaderHeight';
import styles from './styles.module.scss';

const ANIMATION_TIMEOUT = 400;

const InfoPopup = ({ children, extraPopup, onClosePopup, popupButtons, isOpen }) => {
  const [blockScroll, allowScroll] = useScrollBlock();
  const headerHeight = useHeaderHeight();
  const nodeRef = useRef(null);
  const ref = useRef();
  const backgroundRef = useRef();

  // Обработчик клика на background - закрывает попап только при клике на сам background
  const handleBackgroundClick = useCallback(
    (event) => {
      // Закрываем только если клик был именно на background, а не на всплывающем событии
      if (event.target === backgroundRef.current) {
        onClosePopup && onClosePopup();
      }
    },
    [onClosePopup],
  );

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        onClosePopup && onClosePopup();
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [onClosePopup]);

  const handleEnter = useCallback(() => {
    blockScroll();
  }, [blockScroll]);

  const handleExit = useCallback(() => {
    allowScroll();
  }, [allowScroll]);

  const animationClassNames = {
    enter: styles['infoPopup--enter'],
    enterActive: styles['infoPopup--enter-active'],
    exit: styles['infoPopup--exit'],
    exitActive: styles['infoPopup--exit-active'],
  };

  useUnmount(handleExit);

  return (
    <CSSTransition
      in={isOpen}
      classNames={animationClassNames}
      timeout={ANIMATION_TIMEOUT}
      className={styles.infoPopup}
      onEnter={handleEnter}
      onExit={handleExit}
      unmountOnExit
      nodeRef={nodeRef}
    >
      <div ref={nodeRef} style={headerHeight ? { top: headerHeight } : undefined}>
        <div className={styles.infoPopup__background} ref={backgroundRef} onClick={handleBackgroundClick} style={headerHeight ? { top: headerHeight } : undefined} />
        <div className={styles.infoPopup__contentContainer}>
          <div className={styles.infoPopup__wrapper} ref={ref}>
            <div className={styles.infoPopup__closeBtnMobile}>
              <IconButton icon={ICON.close} onClick={onClosePopup} />
            </div>
            <div className={styles.infoPopup__content}>{children && children}</div>
            <div className={styles.infoPopup__buttons}>
              <div className={styles.infoPopup__closeBtn}>
                <IconButton icon={ICON.close} onClick={onClosePopup} />
              </div>
              {popupButtons && popupButtons}
            </div>
            <div
              className={cn(styles.infoPopup__chat, {
                [styles['infoPopup__chat--opened']]: extraPopup,
              })}
            >
              {extraPopup && extraPopup}
            </div>
          </div>
        </div>
      </div>
    </CSSTransition>
  );
};

export default InfoPopup;
